import api from '@/lib/axios';

export interface SendOtpResponse {
  success: boolean;
  data:{
    message: string;
    otp: string;
  }
}

export interface VerifyOtpResponse {
  success: boolean;
  data:{
    message: string;
    token: string;
  }
}

export const authService = {
  sendOtp: async (phone: string): Promise<SendOtpResponse> => {
    const response = await api.post('/auth/send-otp', { phone });
    return response.data;
  },

  verifyOtp: async (phone: string, pin: string): Promise<VerifyOtpResponse> => {
    const response = await api.post('/auth/verify-otp', { phone, pin });
    return response.data;
  },
};